class VideoHtml {
  params: any;
  video: HTMLVideoElement;
  options: { root: null; threshold: number[]; };
  observer: IntersectionObserver;

  constructor(componentRoot: HTMLElement, params: any) {
    this.params = params;
    this.video = componentRoot.querySelector('video') as HTMLVideoElement;

    this.options = {
      root: null,
      threshold: [0, 0.5, 1]
    };

    this.observer = new IntersectionObserver(async ([video]) => {
      // setting video player to async await as shown in mdn example. 
      if (video.isIntersecting && video.intersectionRatio >= 0.5) {
        try {
          await (video.target as HTMLVideoElement).play();
        } catch(err) {
          // if play run into issue that typically means autoplay is disabled
          // in that case we'll set video player to mute then play the video once more
          (video.target as HTMLVideoElement).muted = true;
          await (video.target as HTMLVideoElement).play();
        }
        if (this.params.controls) {
          this.observer.disconnect();
        }
      } else if (video.intersectionRatio === 0) {
        (video.target as HTMLVideoElement).pause();
      }
    }, this.options);

    this.init();
  }

  init () {
    if (!this.params.autoplay) {
      this.observer.observe(this.video);
      this.bindEvents();
    }
  }

  bindEvents () {
    this.video.onended = () => {
      if (!this.params.loop) {
        this.observer.disconnect();
      }
    }
  }
}

export default VideoHtml;